import { rem } from "polished";
import React from "react";
import styled, { css } from "styled-components";
import Button, { ButtonWrapper } from "../../Button";
import Modal from "../../Modal";
import { useDispatch, useSelector } from "react-redux";
import makePayload from "./make-payload";
import { addToCart } from "../../../lib/redux/slices/cart-slice";
import { Spinner } from "../../Spinner";

const AddToCart = ({ stage }) => {
  const [open, onSetModal] = React.useState(false);
  const [previewImage, setPreviewImage] = React.useState("");

  const data = useSelector((s) => s);
  const cartData = useSelector((s) => s.cart);
  const { loading } = cartData;
  const dispatch = useDispatch();

  const setPreview = () => {
    setTimeout(() => {
      if (stage && stage.current) {
        const dataURL = stage.current.toDataURL({
          format: 'jpeg',
          // height: 500,
          quality: 0.5,
          pixelRatio: 2,
          crossOrigin: "anonymous",
        });

        setPreviewImage(dataURL);
      }
    }, 1000);
  };

  
  const handleContinue = async () => {
    const payload = makePayload(data, true, previewImage);
    const { payload: responsePayload } = await dispatch(addToCart(payload));
    window.location.href = responsePayload.redirect_url;
  };

  return (
    <>
      <CartButton>
        <ButtonWrapper>
          <Button
            onClick={() => {
              onSetModal(!open);
              setPreview();
            }}
          >
            Beställ
          </Button>
        </ButtonWrapper>
      </CartButton>

      <Modal
        wrapperId={`modal`}
        isOpen={open}
        overlayClick
        handleClose={() => {
          onSetModal(false);
          setPreviewImage("");
        }}
        styles={{
          maxWidth: "70%",
          maxHeight: "80%",
          height: "100%",
          width: "100%",
          borderRadius: 0,
        }}
        parentStyles={{
          zIndex: 9999,
        }}
        title={""}
        className='center-block'
      >
        <ModalContent>
          {loading === "pending" ? (
            <Spinner
              hasContainer
              strokeWidth={10}
              width={50}
              className="centerAlign"
            />
          ) : null}
          <div className="content-block">
            {previewImage && (
              <div className="preview-image">
                <img src={previewImage} alt="preview" />
              </div>
            )}
            <h6>Grattis!</h6>
            <h2>Du har nu designat din bänkskiva.</h2>
            <p>Är du nöjd så fortsätt till webshopen och din ritning sparas.</p>
          </div>
          <div className="buttons">
            <Button
              skin="red"
              variant="normal"
              onClick={() => {
                onSetModal(false);
                setPreviewImage("");
              }}
            >
              Avbryt
            </Button>
            <Button className="continue" onClick={handleContinue}>
              Fortsätt
            </Button>
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};
export default AddToCart;

const CartButton = styled.div`
  ${({ theme }) => css`
    padding: ${rem(10)};
  `}
`;

const ModalContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    /* justify-content: center; */
    flex-direction: column;
    /* height: 100%; */

    .content-block {
      text-align: center;
      margin-bottom: ${rem(30)};

      h2,
      h6,
      p {
        margin-bottom: 10px;
      }

      .preview-image {
        margin: 20px 0;

        img {
          max-width: 50%;
          /* margin-left: 20%; */
        }
      }
    }
    .buttons {
      display: inline-block;
      margin: 0 -7px;

      .builder-button {
        display: inline-block;
        padding: 0 7px;

        button {
          min-width: 113px;

          &.continue {
            min-width: 200px;
          }
        }
      }
    }
  `}
`;
